import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

export const adminGuard: CanActivateFn = async () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.isLoggedIn) return router.createUrlTree(['/login']);

  const valid = await auth.validateToken();
  if (!valid) return router.createUrlTree(['/login']);

  if (!auth.isAdmin) return router.createUrlTree([auth.homeRoute()]);

  return true;
};
